import { z } from "zod";

/**
 * Icon names. Server-safe: the catalog validates the *shape* of a name; the
 * browser resolves it against the installed Phosphor set and renders nothing
 * for a name it does not know, so a view never breaks on a bad icon.
 */
export const IconNameSchema = z
  .string()
  .regex(
    /^[A-Za-z][A-Za-z0-9]*(?:-[A-Za-z0-9]+)*$/,
    "Icon names are Phosphor names in kebab-case or PascalCase.",
  )
  .max(64)
  .describe(
    'A Phosphor icon name, kebab-case or PascalCase: "warning", "arrow-right", "FileText".',
  );

/** `arrow-right` / `arrowRight` / `ArrowRightIcon` → `ArrowRight`. */
export function toPascalIconName(name: string): string {
  const pascal = name
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join("");
  return pascal.length > 4 && pascal.endsWith("Icon")
    ? pascal.slice(0, -4)
    : pascal;
}
